/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path fill="currentcolor" d="M4 20v-2h13v-2H4v-2h8v-2H4v-2h16V8H4V6h6V4H4V2H2v20h20v-2z" />
  </Icon>
);
export { SvgChartBarH as ChartBarH };
